import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import MainLayout from '../components/layout/MainLayout';

const HomePage = lazy(() => import('../pages/home/page'));
const ArticlesPage = lazy(() => import('../pages/articles/page'));
const GamingPage = lazy(() => import('../pages/gaming/page'));
const StreamingPage = lazy(() => import('../pages/streaming/page'));
const OfficePage = lazy(() => import('../pages/office/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const PrivacyPolicyPage = lazy(() => import('../pages/privacy-policy/page'));
const AffiliateDisclosurePage = lazy(() => import('../pages/affiliate-disclosure/page'));
const ReviewPolicyPage = lazy(() => import('../pages/review-policy/page'));
const ArticlePage = lazy(() => import('../pages/article/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const SitemapPage = lazy(() => import('../pages/sitemap/page'));

const routes: RouteObject[] = [
  // Sitemap route — no layout, renders raw XML directly
  {
    path: '/sitemap.xml',
    element: <SitemapPage />,
  },
  {
    path: '/',
    element: <MainLayout><HomePage /></MainLayout>,
  },
  {
    path: '/articles',
    element: <MainLayout><ArticlesPage /></MainLayout>,
  },
  {
    path: '/gaming',
    element: <MainLayout><GamingPage /></MainLayout>,
  },
  {
    path: '/streaming',
    element: <MainLayout><StreamingPage /></MainLayout>,
  },
  {
    path: '/office',
    element: <MainLayout><OfficePage /></MainLayout>,
  },
  {
    path: '/about',
    element: <MainLayout><AboutPage /></MainLayout>,
  },
  {
    path: '/privacy-policy',
    element: <MainLayout><PrivacyPolicyPage /></MainLayout>,
  },
  {
    path: '/affiliate-disclosure',
    element: <MainLayout><AffiliateDisclosurePage /></MainLayout>,
  },
  {
    path: '/review-policy',
    element: <MainLayout><ReviewPolicyPage /></MainLayout>,
  },
  {
    path: '/article/:slug',
    element: <MainLayout><ArticlePage /></MainLayout>,
  },
  {
    path: '/404',
    element: <MainLayout><NotFoundPage /></MainLayout>,
  },
  {
    path: '*',
    element: <MainLayout><NotFoundPage /></MainLayout>,
  },
];

export default routes;
